module.exports = __webpack_public_path__ + "static/media/030-tooth.d14706c2.svg";